module.exports = __webpack_public_path__ + "media/images/font/Gustavo-LightItalic-ea2f8b973295f9700a9716646d0bfd39.woff";